<div class="flex flex-column gap-4 w-full text-left">
	<label class="context-label text-center w-full">
		{{ translations['enterYourEmailToReceiveAPasswordResetLink'] || 'Enter your email to receive a password reset link.' }}
	</label>

	<form [formGroup]="formGroup" class="flex flex-column gap-3 w-full">
		<div class="flex flex-column align-items-center gap-3 align-self-stretch">
			<!-- Email -->
			<div class="flex flex-column align-items-start gap-2 align-self-stretch w-full">
				<label class="field-label font-semibold text-black" for="email">{{ translations['email'] || 'Email' }}*</label>
				<app-input
					type="email"
					id="email"
					[placeholder]="translations['email'] || 'Email'"
					formControlName="email"
					required
				></app-input>
				<span class="error-message block mt-1" *ngIf="getFieldErrorMessage('email')">
					{{ getFieldErrorMessage('email') }}
				</span>
			</div>
		</div>

		<div class="flex flex-column align-items-center pt-4 gap-4 w-full align-self-stretch">
			<app-button
				class="w-full block"
				[text]="translations['sendResetLink'] || 'Send Reset Link'"
				[type]="getButtonType(formGroup.invalid || (loading$ | async) || !!(loadingStore$ | async))"
				[disabled]="formGroup.invalid || (loading$ | async) || !!(loadingStore$ | async)"
				(buttonClicked)="onRequestResetPassword()"
			></app-button>
		</div>
	</form>

	<div class="w-full text-center mt-3">
		<p class="register-text text-center font-normal line-height-2">
			<a class="text-black cursor-pointer font-bold" (click)="navigateTo(AuthModalComponentEnum.LOGIN)">
				{{ translations['backToSignIn'] || 'Back to Sign In' }}
			</a>
		</p>
	</div>
</div>
